import React from "react";
import TableFindCmp from "./TableFindCmp";
export default function LoanFindPage() {
  return (
    <div>
      <TableFindCmp />
    </div>
  );
}
